export default __webpack_public_path__ + "static/media/n9.8896c9a6.jpeg";